import React, { Component } from 'react';
import { Switch, Route, HashRouter } from 'react-router-dom';
import "./grantaccess.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import ReactHtmlParser from 'react-html-parser';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import DeleteModal from 'LIBRARY/CommonResources/DeleteModal/DeleteModal';
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import Pagination from 'react-js-pagination';
import { getLibraryAccessDetails, setAssignedInstitute } from 'LIBRARY/Actions/AdminDetailsAction.js';
import { connect } from 'react-redux';
import SpecificUserLog from 'LIBRARY/CommonResources/SpecificUserLog/SpecificUserLog';

class GrantAccess extends Component {


    constructor(props) {
        super(props);
        this.state = {
            accessFetching: false,
            accessDetails: {},
            selectedAccessIds: [],
            page_indexAccess: 1,
            limitAccess: 10,
            offsetAccess: 0,
            totalCountAccess: 0,

            // VARIABLES TO GET FACULTY LIST
            facultyList: {},

            // VARIABLES TO ADD ACCESS
            addAccess: false,
            addingAccess: false,
            isEditMode: '',
            accessUniqueId: '',
            tempFacultyIds: [],
            facultyIds: [],
            selectEmployeeWarning: '',
            accessObject: {},
            accessWarning: '',
            selectedFaculty: '',

            // METHOD TO RETURN DELETE ACCESS
            deleteAccess: false,
            deletingAccess: '',
            deleteAccessText: '',
            deleteWarning: '',

            //SUCCESS MODAL VARIABLES
            successModal: false,
            successModalType: "",
            successMessage: "",
            iidArray:  this.props.iidArray.iidArray,
            searchTerm: '',
            selectedIID: "",
            // assignedInstitute: this.props.assignedInstitute,
            assignedInstitute:  this.props.iidArray.iidArray,
            employeeList: [],
            employeeListFetching: false,
            offset: 0,
            page_index: 1,
            limit: 10,
            employeeCount: 0,

            showActivitySlider: false,
            selectedIid:"",
            hoverID:"",
        };
    }


    componentDidMount() {

        // METHOD CALLED TO GET ACCESS DETAILS
        this.apiCallToGetAccessDetails();

        // API CALL TO GET FACULTY LIST
        this.apiCallToGetEmployeeList();
    }

    // API CALL METHOD TO GET ACCESS DETAILS
    apiCallToGetAccessDetails = async () => {
        this.setState({
            accessFetching: true
        });

        let requestData = {
            "institute_id": config.institute_id,
            iidArray:  this.props.iidArray.iidArray,
            "offset": this.state.offsetAccess,
            "limit": this.state.limitAccess
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getLibraryUserAccess',
            requestData,
            '/api/library/libraryGrantAccess.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAccessDetails();
            }, 1000);
        }
        else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    accessDetails: apiResult,
                    accessFetching: false,
                    totalCountAccess: jsonResponse.APIResult.userAccessCount
                });
            }
            else {
                this.setState({
                    accessFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting access details. Please try again later.'
                });
            }
        }
    }

    // API METHOD TO GET EMPLOYEE LIST
    apiCallToGetEmployeeList = async () => {
        this.setState({
            employeeListFetching: true
        });

        let requestData = {
            "iid": this.state.selectedIID,
            "page_index": this.state.page_index,
            "limit": this.state.limit,
            "type": "all",
            "status": "",
            "role": "",
            "search": this.state.searchTerm,
            "selectedStream": "",
            "selectedDepartment": 0,
            isInstituteNameRequired: "true",
            iidArray: this.state.selectedIID > 0 ? [this.state.selectedIID] :  this.props.iidArray.iidArray
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getMultipleInstituteRegisteredFacultyList',
            requestData,
            '/api/instructor/facultyRegistration.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetEmployeeList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    employeeList: apiResult,
                    employeeListFetching: false,
                    employeeCount: jsonResponse.APIResult.totalRecords
                });
            } else {
                this.setState({
                    employeeListFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting employee list. Please try again later.'
                });
            }
        }
    }

    // METHOD TO GET LIMIT PER PAGE
    getLimitPerPage = (e) => {
        this.setState({
            page_index: 1,
            limit: e.target.value,
            offset: 0
        }, () => {
            this.apiCallToGetEmployeeList();
        });
    }

    // METHOD TO CLOSE ADD ACCESS
    closeAddAccess = () => {
        this.setState({
            addAccess: false,
            addingAccess: false,
            isEditMode: '',
            accessUniqueId: '',
            tempFacultyIds: [],
            facultyIds: [],
            selectEmployeeWarning: '',
            accessObject: {},
            accessWarning: '',
            selectedFaculty: ''
        });
    }

    // METHOD TO CLOSE SELECT EMPLOYEE
    closeSelectEmployee = () => {
        let tempFacultyIds = this.state.tempFacultyIds;
        tempFacultyIds = [];

        if (this.state.facultyIds.length > 0) {
            this.state.facultyIds.map(facultyId => {
                tempFacultyIds.push(facultyId);
            });
        }

        this.setState({
            searchTerm: '',
            selectedIID: '',
            selectEmployees: false,
            tempFacultyIds
        }, () => {
            this.apiCallToGetEmployeeList();
        });
    }

    // METHOD TO UPDATE ACCESS OBJECT
    updateAccessObject = (screen, access) => {
        let accessObject = this.state.accessObject;

        if (accessObject[screen] == undefined) {
            accessObject[screen] = [];
        }

        if (accessObject[screen].includes(access)) {
            accessObject[screen] = accessObject[screen].filter(accessName => accessName != access);
        } else {
            accessObject[screen].push(access);
        }

        if (accessObject[screen].length == 0) {
            delete accessObject[screen];
        }

        this.setState({
            accessObject
        });
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false,
        });
    }

    // METHOD TO VALIDATE ADD ACCESS
    validateAddAccess = () => {
        let validData = true;

        if (!this.state.isEditMode) {
            if (this.state.facultyIds.length < 1) {
                this.setState({
                    selectEmployeeWarning: 'Please select employee to grant access.'
                });
                validData = false;
            }
        }

        if (Object.keys(this.state.accessObject).length < 1) {
            this.setState({
                accessWarning: 'Please select access screen to grant access.'
            });
            validData = false;
        }

        if (validData) {
            if (this.state.isEditMode) {
                // METHOD CALLED TO UPDATE ACCESS DETAILS
                this.apiCallToUpdateAccess();
            } else {
                // METHOD CALLED TO GRANT ACCESS DETAILS
                this.apiCallToGrantAccess();
            }
        }
    }

    // METHOD TO UPDATE PAGINATION COUNT
    updatePaginationCount = (pageNumber) => {
        this.setState({
            page_index: pageNumber,
            offset: (pageNumber - 1) * this.state.limit,
            tempFacultyIds: [],
            facultyIds: [],
        }, () => {
            this.apiCallToGetEmployeeList();
        });
    }

    // METHOD TO GET LIMIT PER PAGE
    getLimitPerPageAccess = (e) => {
        this.setState({
            page_indexAccess: 1,
            limitAccess: e.target.value,
            offsetAccess: 0
        }, () => {
            this.apiCallToGetAccessDetails();
        });
    }

    // METHOD TO UPDATE PAGINATION COUNT
    updatePaginationCountAccess = (pageNumber) => {
        this.setState({
            page_indexAccess: pageNumber,
            offsetAccess: (pageNumber - 1) * this.state.limitAccess,
            selectedAccessIds: [],

        }, () => {
            this.apiCallToGetAccessDetails();
        });
    }

    // METHOD TO GET ACCESS UPDATE DETAILS
    getAccessUpdateDetails = () => {

        const editGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['setting'].find(access => access === 'edit');

        if (editGrantAccess !== undefined) {

            if (this.state.selectedAccessIds.length > 1) {
                this.setState({
                    successModal: true,
                    successModalType: 'warning',
                    successMessage: 'Please select only one faculty to update access.'
                });
            } else {
                this.setState({
                    addAccess: true,
                    isEditMode: true,
                    accessObject: { ...this.state.accessDetails[this.state.selectedAccessIds.toString()].access },
                    selectedFaculty: this.state.accessDetails[this.state.selectedAccessIds.toString()].facultyId,
                    accessUniqueId: this.state.accessDetails[this.state.selectedAccessIds.toString()].uniqueId
                });
            }
        }
        else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // METHOD TO SELECT FACULTY
    selectFaculty = (facultyId) => {
        let tempFacultyIds = this.state.tempFacultyIds;

        if (tempFacultyIds.includes(facultyId)) {
            tempFacultyIds = tempFacultyIds.filter(id => id != facultyId);
        } else {
            tempFacultyIds.push(facultyId);
        }

        this.setState({
            tempFacultyIds
        });
    }

    selectAllFaculties = () => {
        let tempFacultyIds = this.state.tempFacultyIds;

        if (this.state.employeeList.length == tempFacultyIds.length) {
            tempFacultyIds = []
        } else {
            tempFacultyIds = [];
            this.state.employeeList.map((employee, index) => {
                tempFacultyIds.push(employee.faculty_id);
            })

        }

        this.setState({
            tempFacultyIds: tempFacultyIds
        })
    }

    // METHOD TO CONFIRM FACULTY SELECTION
    confirmFacultySelection = () => {
        let facultyIds = this.state.facultyIds;
        facultyIds = [];

        if (this.state.tempFacultyIds.length > 0) {
            this.state.tempFacultyIds.map(facultyId => {
                facultyIds.push(facultyId);
            });
        }

        this.setState({
            selectEmployees: false,
            facultyIds,
            selectEmployeeWarning: ''
        });
    }

    // METHOD TO REMOVE FACULTY
    removeFaculty = (facultyId) => {
        let tempFacultyIds = this.state.tempFacultyIds;
        let facultyIds = this.state.facultyIds;

        tempFacultyIds = tempFacultyIds.filter(id => id != facultyId);
        facultyIds = facultyIds.filter(id => id != facultyId);

        this.setState({
            tempFacultyIds,
            facultyIds
        });
    }

    // API CALL METHOD TO GRANT ACCESS
    apiCallToGrantAccess = async () => {
        this.setState({
            addingAccess: true
        });

        let facultyObject = {};

        this.state.facultyIds.map(facultyId => {
            facultyObject[facultyId] = this.state.accessObject;
        });

        let requestData = {
            "institute_id": config.institute_id,
            "facultyObject": facultyObject,
            "addedBy": config.faculty_id
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'addLibraryUserAccess',
            requestData,
            '/api/library/libraryGrantAccess.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGrantAccess();
            }, 1000);
        }
        else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == 'success') {
                    this.setState({
                        successModal: true,
                        successModalType: 'success',
                        successMessage: apiResult.message,
                        addingAccess: false
                    }, () => {
                        this.apiCallToGetAccessDetails();
                    });

                    this.closeAddAccess();
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                        addingAccess: false
                    });
                }
            }
            else {
                this.setState({
                    addingAccess: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while granting access. Please try again later.'
                });
            }
        }
    }

    // API  CALL METHOD TO UPDATE ACCESS DETAILS
    apiCallToUpdateAccess = async () => {
        this.setState({
            addingAccess: true
        });

        let requestData = {
            "institute_id": config.institute_id,
            "iidArray":  this.props.iidArray.iidArray,
            "facultyId": this.state.selectedFaculty,
            "accessObject": this.state.accessObject,
            "updatedBy": config.faculty_id,
            "uniqueId": this.state.accessUniqueId
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'updateLibraryUserAccess',
            requestData,
            '/api/library/libraryGrantAccess.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToUpdateAccess();
            }, 1000);
        }
        else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                let accessDetails = this.state.accessDetails;

                if (apiResult.status == 'success') {
                    accessDetails[this.state.accessUniqueId].uniqueId = this.state.accessUniqueId;
                    accessDetails[this.state.accessUniqueId].facultyId = this.state.selectedFaculty;
                    accessDetails[this.state.accessUniqueId].facultyName = accessDetails[this.state.accessUniqueId].facultyName;
                    accessDetails[this.state.accessUniqueId].facultyRole = accessDetails[this.state.accessUniqueId].facultyRole;
                    accessDetails[this.state.accessUniqueId].addedBy = accessDetails[this.state.accessUniqueId].addedBy;
                    accessDetails[this.state.accessUniqueId].updatedBy = config.faculty_id;
                    accessDetails[this.state.accessUniqueId].addedByName = accessDetails[this.state.accessUniqueId].addedByName;
                    accessDetails[this.state.accessUniqueId].updatedByName = config.instructorInfo.FirstName + ' ' + config.instructorInfo.LastName;
                    accessDetails[this.state.accessUniqueId].access = this.state.accessObject;

                    this.setState({
                        successModal: true,
                        successModalType: 'success',
                        successMessage: apiResult.message,
                        addingAccess: false,
                        accessDetails,
                        selectedAccessIds: []
                    });

                    this.closeAddAccess();
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                        addingAccess: false
                    });
                }
            }
            else {
                this.setState({
                    addingAccess: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while granting access. Please try again later.'
                });
            }
        }
    }

    // API CALL METHOD TO DELETE ACCESS
    apiCallToDeleteAccess = async () => {
        this.setState({
            deletingAccess: true
        });

        let requestData = {
            "institute_id": config.institute_id,
            "iidArray":  this.props.iidArray.iidArray,
            "uniqueIdArray": this.state.selectedAccessIds,
            "facultyId": config.faculty_id
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'deleteLibraryUserAccess',
            requestData,
            '/api/library/libraryGrantAccess.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToDeleteAccess();
            }, 1000);
        }
        else {
            this.closeDeleteAccess();
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                let accessDetails = this.state.accessDetails;

                if (apiResult.status == 'success') {
                    apiResult.deletedUniqueIds.map(uniqueId => {
                        delete accessDetails[uniqueId];
                    });

                    this.setState({
                        deletingAccess: false,
                        successModal: true,
                        successModalType: 'success',
                        successMessage: apiResult.message,
                        accessDetails,
                        selectedAccessIds: []
                    });
                } else {
                    this.setState({
                        deletingAccess: false,
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message
                    });
                }
            }
            else {
                this.setState({
                    deletingAccess: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while deleting access. Please try again later.'
                });
            }
        }
    }


    // METHOD TO RETURN GRANT ACCESS
    returnGrantAccess = () => {
        return (
            <div id="addAccessSideMenu" style={{ display: this.state.addAccess ? 'flex' : 'none' }}>
                <div id="addAccessDataContainer">
                    <div id="addAccessHeader" className="row">
                        <FontAwesomeIcon icon={['fas', 'times']} size="lg" color="#000" onClick={() => this.closeAddAccess()} style={{ cursor: "pointer" }} />
                        <h3 className="col-11">{this.state.isEditMode ? 'Update Access' : 'Grant New Access'}</h3>
                    </div>
                    <div id="addAccessBody">
                        {
                            !this.state.isEditMode &&
                            <div className="grantEmployees">
                                <label style={{ fontSize: 14, marginBottom: 0, fontWeight: 'bold' }}>Select Employees <span style={{ color: 'red' }}>*</span></label>
                                <input
                                    type="text"
                                    className="form-control addAccessInput"
                                    placeholder="Click here to select responsible faculty"
                                    onClick={() => this.setState({ selectEmployees: true })}
                                    readOnly
                                />
                                <p className="text-danger" style={{ fontSize: 14 }}>{this.state.selectEmployeeWarning}</p>
                                <div style={{ maxHeight: 300, overflowY: "auto" }}>
                                    {
                                        this.state.facultyIds.length > 0 &&
                                        this.state.facultyIds.map(facultyId => {
                                            return this.state.employeeList.map((employee) => {
                                                if (employee.faculty_id == facultyId) {
                                                    return (
                                                        <div className="selected-employee">
                                                            {employee.faculty_fname + ' ' + employee.faculty_lname}
                                                            <FontAwesomeIcon icon={['fas', 'times']} style={{ cursor: 'pointer', marginLeft: 5 }} title="Click to remove faculty" onClick={() => this.removeFaculty(facultyId)} />
                                                        </div>
                                                    );
                                                }
                                            })
                                        })
                                    }
                                </div>
                            </div>
                        }
                        <div className="grantAccess" style={{ marginTop: 10 }}>
                            <label style={{ fontSize: 14, marginBottom: 0, fontWeight: 'bold' }}>Grant Access Screen <span style={{ color: 'red' }}>*</span></label>
                            <table className="table">
                                <thead>
                                    <th style={{ padding: 5 }}></th>
                                    <th style={{ padding: 5 }}>View</th>
                                    <th style={{ padding: 5 }}>Add</th>
                                    <th style={{ padding: 5 }}>Edit/Modify</th>
                                    <th style={{ padding: 5 }}>Delete</th>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ padding: 5 }}>Resource</td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['resource'] != undefined && this.state.accessObject['resource'].includes('view')}
                                                onChange={() => this.updateAccessObject('resource', 'view')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['resource'] != undefined && this.state.accessObject['resource'].includes('add')}
                                                onChange={() => this.updateAccessObject('resource', 'add')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['resource'] != undefined && this.state.accessObject['resource'].includes('edit')}
                                                onChange={() => this.updateAccessObject('resource', 'edit')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['resource'] != undefined && this.state.accessObject['resource'].includes('delete')}
                                                onChange={() => this.updateAccessObject('resource', 'delete')}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: 5 }}>Issue/Return Resource</td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['issue/return'] != undefined && this.state.accessObject['issue/return'].includes('view')}
                                                onChange={() => this.updateAccessObject('issue/return', 'view')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['issue/return'] != undefined && this.state.accessObject['issue/return'].includes('add')}
                                                onChange={() => this.updateAccessObject('issue/return', 'add')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['issue/return'] != undefined && this.state.accessObject['issue/return'].includes('edit')}
                                                onChange={() => this.updateAccessObject('issue/return', 'edit')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['issue/return'] != undefined && this.state.accessObject['issue/return'].includes('delete')}
                                                onChange={() => this.updateAccessObject('issue/return', 'delete')}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: 5 }}>Periodicals</td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['periodicals'] != undefined && this.state.accessObject['periodicals'].includes('view')}
                                                onChange={() => this.updateAccessObject('periodicals', 'view')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['periodicals'] != undefined && this.state.accessObject['periodicals'].includes('add')}
                                                onChange={() => this.updateAccessObject('periodicals', 'add')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['periodicals'] != undefined && this.state.accessObject['periodicals'].includes('edit')}
                                                onChange={() => this.updateAccessObject('periodicals', 'edit')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['periodicals'] != undefined && this.state.accessObject['periodicals'].includes('delete')}
                                                onChange={() => this.updateAccessObject('periodicals', 'delete')}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: 5 }}>e-Resources</td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['e-resources'] != undefined && this.state.accessObject['e-resources'].includes('view')}
                                                onChange={() => this.updateAccessObject('e-resources', 'view')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['e-resources'] != undefined && this.state.accessObject['e-resources'].includes('add')}
                                                onChange={() => this.updateAccessObject('e-resources', 'add')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['e-resources'] != undefined && this.state.accessObject['e-resources'].includes('edit')}
                                                onChange={() => this.updateAccessObject('e-resources', 'edit')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['e-resources'] != undefined && this.state.accessObject['e-resources'].includes('delete')}
                                                onChange={() => this.updateAccessObject('e-resources', 'delete')}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: 5 }}>Rules</td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['rules'] != undefined && this.state.accessObject['rules'].includes('view')}
                                                onChange={() => this.updateAccessObject('rules', 'view')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['rules'] != undefined && this.state.accessObject['rules'].includes('add')}
                                                onChange={() => this.updateAccessObject('rules', 'add')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['rules'] != undefined && this.state.accessObject['rules'].includes('edit')}
                                                onChange={() => this.updateAccessObject('rules', 'edit')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['rules'] != undefined && this.state.accessObject['rules'].includes('delete')}
                                                onChange={() => this.updateAccessObject('rules', 'delete')}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: 5 }}>Library Entry</td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['library entry'] != undefined && this.state.accessObject['library entry'].includes('view')}
                                                onChange={() => this.updateAccessObject('library entry', 'view')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['library entry'] != undefined && this.state.accessObject['library entry'].includes('add')}
                                                onChange={() => this.updateAccessObject('library entry', 'add')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['library entry'] != undefined && this.state.accessObject['library entry'].includes('edit')}
                                                onChange={() => this.updateAccessObject('library entry', 'edit')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['library entry'] != undefined && this.state.accessObject['library entry'].includes('delete')}
                                                onChange={() => this.updateAccessObject('library entry', 'delete')}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: 5 }}>Publisher</td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['publisher'] != undefined && this.state.accessObject['publisher'].includes('view')}
                                                onChange={() => this.updateAccessObject('publisher', 'view')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['publisher'] != undefined && this.state.accessObject['publisher'].includes('add')}
                                                onChange={() => this.updateAccessObject('publisher', 'add')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['publisher'] != undefined && this.state.accessObject['publisher'].includes('edit')}
                                                onChange={() => this.updateAccessObject('publisher', 'edit')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['publisher'] != undefined && this.state.accessObject['publisher'].includes('delete')}
                                                onChange={() => this.updateAccessObject('publisher', 'delete')}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: 5 }}>Donor's List</td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['donor list'] != undefined && this.state.accessObject['donor list'].includes('view')}
                                                onChange={() => this.updateAccessObject('donor list', 'view')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['donor list'] != undefined && this.state.accessObject['donor list'].includes('add')}
                                                onChange={() => this.updateAccessObject('donor list', 'add')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['donor list'] != undefined && this.state.accessObject['donor list'].includes('edit')}
                                                onChange={() => this.updateAccessObject('donor list', 'edit')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['donor list'] != undefined && this.state.accessObject['donor list'].includes('delete')}
                                                onChange={() => this.updateAccessObject('donor list', 'delete')}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: 5 }}>Print Barcode</td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['print barcode'] != undefined && this.state.accessObject['print barcode'].includes('view')}
                                                onChange={() => this.updateAccessObject('print barcode', 'view')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['print barcode'] != undefined && this.state.accessObject['print barcode'].includes('add')}
                                                onChange={() => this.updateAccessObject('print barcode', 'add')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['print barcode'] != undefined && this.state.accessObject['print barcode'].includes('edit')}
                                                onChange={() => this.updateAccessObject('print barcode', 'edit')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['print barcode'] != undefined && this.state.accessObject['print barcode'].includes('delete')}
                                                onChange={() => this.updateAccessObject('print barcode', 'delete')}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: 5 }}>Stock Verification</td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['stock verification'] != undefined && this.state.accessObject['stock verification'].includes('view')}
                                                onChange={() => this.updateAccessObject('stock verification', 'view')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['stock verification'] != undefined && this.state.accessObject['stock verification'].includes('add')}
                                                onChange={() => this.updateAccessObject('stock verification', 'add')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['stock verification'] != undefined && this.state.accessObject['stock verification'].includes('edit')}
                                                onChange={() => this.updateAccessObject('stock verification', 'edit')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['stock verification'] != undefined && this.state.accessObject['stock verification'].includes('delete')}
                                                onChange={() => this.updateAccessObject('stock verification', 'delete')}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: 5 }}>Resource Category</td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['resource category'] != undefined && this.state.accessObject['resource category'].includes('view')}
                                                onChange={() => this.updateAccessObject('resource category', 'view')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['resource category'] != undefined && this.state.accessObject['resource category'].includes('add')}
                                                onChange={() => this.updateAccessObject('resource category', 'add')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['resource category'] != undefined && this.state.accessObject['resource category'].includes('edit')}
                                                onChange={() => this.updateAccessObject('resource category', 'edit')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['resource category'] != undefined && this.state.accessObject['resource category'].includes('delete')}
                                                onChange={() => this.updateAccessObject('resource category', 'delete')}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: 5 }}>Resource Location</td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['resource location'] != undefined && this.state.accessObject['resource location'].includes('view')}
                                                onChange={() => this.updateAccessObject('resource location', 'view')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['resource location'] != undefined && this.state.accessObject['resource location'].includes('add')}
                                                onChange={() => this.updateAccessObject('resource location', 'add')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['resource location'] != undefined && this.state.accessObject['resource location'].includes('edit')}
                                                onChange={() => this.updateAccessObject('resource location', 'edit')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['resource location'] != undefined && this.state.accessObject['resource location'].includes('delete')}
                                                onChange={() => this.updateAccessObject('resource location', 'delete')}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: 5 }}>Resource Requisition</td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['resource requisition'] != undefined && this.state.accessObject['resource requisition'].includes('view')}
                                                onChange={() => this.updateAccessObject('resource requisition', 'view')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['resource requisition'] != undefined && this.state.accessObject['resource requisition'].includes('add')}
                                                onChange={() => this.updateAccessObject('resource requisition', 'add')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['resource requisition'] != undefined && this.state.accessObject['resource requisition'].includes('edit')}
                                                onChange={() => this.updateAccessObject('resource requisition', 'edit')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['resource requisition'] != undefined && this.state.accessObject['resource requisition'].includes('delete')}
                                                onChange={() => this.updateAccessObject('resource requisition', 'delete')}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: 5 }}>Purchase Request</td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['purchase request'] != undefined && this.state.accessObject['purchase request'].includes('view')}
                                                onChange={() => this.updateAccessObject('purchase request', 'view')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['purchase request'] != undefined && this.state.accessObject['purchase request'].includes('add')}
                                                onChange={() => this.updateAccessObject('purchase request', 'add')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['purchase request'] != undefined && this.state.accessObject['purchase request'].includes('edit')}
                                                onChange={() => this.updateAccessObject('purchase request', 'edit')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['purchase request'] != undefined && this.state.accessObject['purchase request'].includes('delete')}
                                                onChange={() => this.updateAccessObject('purchase request', 'delete')}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: 5 }}>Reports</td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['reports'] != undefined && this.state.accessObject['reports'].includes('view')}
                                                onChange={() => this.updateAccessObject('reports', 'view')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['reports'] != undefined && this.state.accessObject['reports'].includes('add')}
                                                onChange={() => this.updateAccessObject('reports', 'add')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['reports'] != undefined && this.state.accessObject['reports'].includes('edit')}
                                                onChange={() => this.updateAccessObject('reports', 'edit')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['reports'] != undefined && this.state.accessObject['reports'].includes('delete')}
                                                onChange={() => this.updateAccessObject('reports', 'delete')}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: 5 }}>Membership</td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['membership'] != undefined && this.state.accessObject['membership'].includes('view')}
                                                onChange={() => this.updateAccessObject('membership', 'view')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['membership'] != undefined && this.state.accessObject['membership'].includes('add')}
                                                onChange={() => this.updateAccessObject('membership', 'add')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['membership'] != undefined && this.state.accessObject['membership'].includes('edit')}
                                                onChange={() => this.updateAccessObject('membership', 'edit')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['membership'] != undefined && this.state.accessObject['membership'].includes('delete')}
                                                onChange={() => this.updateAccessObject('membership', 'delete')}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: 5 }}>Invoice</td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['invoice'] != undefined && this.state.accessObject['invoice'].includes('view')}
                                                onChange={() => this.updateAccessObject('invoice', 'view')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['invoice'] != undefined && this.state.accessObject['invoice'].includes('add')}
                                                onChange={() => this.updateAccessObject('invoice', 'add')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['invoice'] != undefined && this.state.accessObject['invoice'].includes('edit')}
                                                onChange={() => this.updateAccessObject('invoice', 'edit')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['invoice'] != undefined && this.state.accessObject['invoice'].includes('delete')}
                                                onChange={() => this.updateAccessObject('invoice', 'delete')}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: 5 }}>No Due Certificate</td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['noDueCertificate'] != undefined && this.state.accessObject['noDueCertificate'].includes('view')}
                                                onChange={() => this.updateAccessObject('noDueCertificate', 'view')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['noDueCertificate'] != undefined && this.state.accessObject['noDueCertificate'].includes('add')}
                                                onChange={() => this.updateAccessObject('noDueCertificate', 'add')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['noDueCertificate'] != undefined && this.state.accessObject['noDueCertificate'].includes('edit')}
                                                onChange={() => this.updateAccessObject('noDueCertificate', 'edit')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['noDueCertificate'] != undefined && this.state.accessObject['noDueCertificate'].includes('delete')}
                                                onChange={() => this.updateAccessObject('noDueCertificate', 'delete')}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: 5 }}>Setting</td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['setting'] != undefined && this.state.accessObject['setting'].includes('view')}
                                                onChange={() => this.updateAccessObject('setting', 'view')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['setting'] != undefined && this.state.accessObject['setting'].includes('add')}
                                                onChange={() => this.updateAccessObject('setting', 'add')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['setting'] != undefined && this.state.accessObject['setting'].includes('edit')}
                                                onChange={() => this.updateAccessObject('setting', 'edit')}
                                            />
                                        </td>
                                        <td style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.accessObject['setting'] != undefined && this.state.accessObject['setting'].includes('delete')}
                                                onChange={() => this.updateAccessObject('setting', 'delete')}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div id="addAccessFooter">
                        {
                            this.state.addingAccess &&
                            <Spinner />
                        }
                        <button className="btn btn-primary" onClick={() => this.validateAddAccess()} disabled={this.state.addingAccess}>{this.state.isEditMode ? 'Update' : 'Add'}</button>
                        <button className="btn btn-outline-primary waves-effect" onClick={() => this.closeAddAccess()}>Cancel</button>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO RETURN SELECT FACULTY
    returnSelectFaculty = () => {
        return (
            <div className={this.state.selectEmployees ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog" style={{ marginLeft: '25%', }}>
                    <div className="modal-content" style={{ width: '50vw', height: '90vh' }}>
                        {/* <div className="modal-header addAccessHeader" style={{backgroundColor: "#0465ac"}}>
                            <h2 style={{color: "white"}}>Select Faculty</h2>
                            <FontAwesomeIcon icon={['fas', 'times']} size="lg" color="white" onClick={() => this.closeSelectEmployee()} style={{ cursor: "pointer" }} />
                        </div> */}
                        <div className="modal-header" id="addAccessHeader">
                            <h2 style={{ color: "white", fontSize: "24px" }}>Select Faculty</h2>
                            <FontAwesomeIcon icon={['fas', 'times']} size="lg" color="white" onClick={() => this.closeSelectEmployee()} style={{ cursor: "pointer" }} />
                        </div>
                        <div className="modal-body" style={{ maxHeight: '100vh' }}>
                            <div className='searchTerm' style={{ marginTop: 10 }}>
                                <label style={{ fontWeight: 'bold', marginBottom: 0 }}>Search</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search Employee..."
                                    value={this.state.searchTerm}
                                    onChange={(e) => this.setState({ searchTerm: e.target.value, page_index: 1 })}
                                    onKeyPress={(e) => e.charCode == 13 && this.apiCallToGetEmployeeList()}
                                />
                                <p className="info-msg">Press Enter to search.</p>
                            </div>
                            <div className="departmentList pt-4 pb-3">
                                <label style={{ fontWeight: 'bold', marginBottom: 0 }}>Institute</label>
                                <select
                                    className="form-control"
                                    value={this.state.selectedIID}
                                    onChange={(e) => this.setState({ selectedIID: e.target.value, page_index: 1 }, () => { this.apiCallToGetEmployeeList(); })}
                                >
                                    <option value=''>Select Institute</option>

                                    {
                                        Object.values(this.props.multipleInstituteDetails.multipleInstituteDetails).map(institute => {
                                            return (
                                               <option value={institute.iid}>{institute.institute_name}</option>
                                            );
                                        })
                                    }
                                </select>
                            </div>
                            <div className='ReceiptsDiv'>
                                <div>
                                    {
                                        this.state.employeeListFetching ?
                                            <div class="spinner-border text-secondary" role="status">
                                                {/* <span class="visually-hidden">Loading...</span> */}
                                            </div>
                                            :
                                            <>
                                                <div className="  mt-2">

                                                    <table class="table">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={this.state.tempFacultyIds.length > 0 && this.state.tempFacultyIds.length == this.state.employeeList.length}
                                                                        onChange={() => this.selectAllFaculties()}
                                                                        style={{ marginRight: 5 }}
                                                                    />
                                                                </th>
                                                                <th scope="col">Sr. No.</th>
                                                                <th scope="col">Designation</th>
                                                                <th scope="col">Employee Name</th>
                                                                <th scope="col">Short Code</th>
                                                                <th scope="col">Role</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                this.state.employeeList.length > 0 ?
                                                                    Object.values(this.state.employeeList).map((employee, index) => {
                                                                        return (
                                                                            <>
                                                                                <tr>
                                                                                    <th style={{ paddingBottom: '4px' }}>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={this.state.tempFacultyIds.includes(employee.faculty_id.toString())}
                                                                                            onChange={() => this.selectFaculty(employee.faculty_id.toString())}
                                                                                            style={{ marginRight: 5 }}
                                                                                        />
                                                                                    </th>
                                                                                    <td className="tableRows">{this.state.offset + index + 1}</td>
                                                                                    <td className="tableRows" title={employee["designation"]}>{employee["designation"]}</td>
                                                                                    {/* <td className="tableRows" title={employee["designation"]}>{employee["designation"].length > 20 ? employee["designation"].substring(0, 20) + '...' : employee["designation"]}</td> */}
                                                                                    <td className="tableRows">{employee["faculty_fname"]} {employee["faculty_lname"]}</td>
                                                                                    <td className="tableRows">{employee["institute_short_name"]}</td>
                                                                                    <td className="tableRows">{employee["userrole"]}</td>
                                                                                </tr>
                                                                            </>
                                                                        )
                                                                    })
                                                                    :
                                                                    <tr>
                                                                        <td colSpan={6}>Employee not found. Please alter your filter.</td>
                                                                    </tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                    {/* <table className="table sticky-top"> */}
                                                    {/* <thead style={{ borderColor: "transparent" }}>
                                                            <tr style={{  }} >
                                                                <input
                                                                    type="checkbox"
                                                                    checked={this.state.tempFacultyIds.length > 0 && this.state.tempFacultyIds.length == this.state.employeeList.length}
                                                                    onChange={() => this.selectAllFaculties()}
                                                                    style={{ marginRight: 5 }}
                                                                />
                                                                <th className=''>Sr. No.</th>
                                                                <th className=''>Designation</th>
                                                                <th className='' >Employee Name</th>
                                                                <th className='' >Short Code</th>
                                                                <th className='' >Role</th>
                                                            </tr>
                                                            <tr>
                                                                <div style={{ height: 10 }}></div>
                                                            </tr>
                                                        </thead> */}
                                                    {/* <tbody style={{ borderTop: 'none' }}>
                                                            {
                                                                this.state.employeeList.length > 0 ?
                                                                    Object.values(this.state.employeeList).map((employee, index) => {
                                                                        return (
                                                                            <> */}
                                                    {/* <tr style={{ boxShadow: "0px 4px 4px rgba(4, 101, 172, 0.1)", borderRadius: "5px 5px 0px 0px", backgroundColor: "white" }}> */}
                                                    {/* <tr style={{border:'none'}}>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={this.state.tempFacultyIds.includes(employee.faculty_id.toString())}
                                                                                        onChange={() => this.selectFaculty(employee.faculty_id.toString())}
                                                                                        style={{ marginRight: 5 }}
                                                                                    />
                                                                                    <td className='tableRow' >{this.state.offset + index + 1}</td>
                                                                                    <td className='tableRow'>{employee["designation"]}</td>
                                                                                    <td className='tableRow'>{employee["faculty_fname"]} {employee["faculty_lname"]}</td>
                                                                                    <td className='tableRow'>{employee["institute_short_name"]}</td>
                                                                                    <td className='tableRow'>{employee["userrole"]}</td>

                                                                                </tr>
                                                                                <tr>
                                                                                    <div style={{ height: 10 }}></div>
                                                                                </tr> */}
                                                    {/* </>
                                                                        )
                                                                    })
                                                                    :
                                                                    <tr>
                                                                        <td colSpan={6}>Employee not found. Please alter your filter.</td>
                                                                    </tr>
                                                            }
                                                        </tbody> */}
                                                    {/* </table> */}
                                                </div>
                                                <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', flexWrap: "nowrap", marginBottom: 15 }}>
                                                    <div className="perPageSelectContainer" style={{ fontSize: 13, fontWeight: "bold" }}>
                                                        <span >Show</span>
                                                        <select
                                                            className="mx-2"
                                                            value={this.state.limit}
                                                            onChange={(e) => this.getLimitPerPage(e)}
                                                        >
                                                            <option value={10}>10</option>
                                                            <option value={25}>25</option>
                                                            <option value={40}>40</option>
                                                            <option value={100}>100</option>
                                                            <option value={250}>250</option>
                                                        </select>
                                                        <span>entries</span>
                                                    </div>
                                                    {
                                                        this.state.employeeList.length > 0 &&
                                                        <div id="paginationContainer">
                                                            <Pagination
                                                                activePage={this.state.page_index}
                                                                itemsCountPerPage={this.state.limit}
                                                                totalItemsCount={parseInt(this.state.employeeCount)}
                                                                pageRangeDisplayed={3}
                                                                onChange={(num) => this.updatePaginationCount(num)}
                                                            />
                                                        </div>
                                                    }
                                                    <p className="mx-2" style={{ fontWeight: 'bold', fontSize: 13 }}>Total Records: {this.state.employeeCount}</p>
                                                </div>
                                            </>
                                    }
                                </div>
                            </div>

                        </div>
                        <div className="modal-footer">
                            <button className="btn primary-button" onClick={() => this.confirmFacultySelection()} disabled={this.state.tempFacultyIds.length == 0}>Select</button>
                            <button className="btn outline-button" onClick={() => this.closeSelectEmployee()}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div >
        );
    }

    // METHOD TO RETURN DELETE ACCESS
    returnDeleteAccess = () => {
        return (
            <div className={this.state.deleteAccess ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog" style={{ marginTop: '10%', marginLeft: '25%', }} >
                    <div className="modal-content " style={{ width: '50vw' }}>
                        <div className="modal-header  deleteModalHeader">
                            <h2 style={{ color: "white" }}><FontAwesomeIcon icon={['fas', 'exclamation-triangle']} color="white" size="am" style={{ marginRight: 20 }} /> Are you sure?</h2>
                            <FontAwesomeIcon icon={['fas', 'times']} size="lg" color="white" onClick={() => this.closeDeleteAccess()} style={{ cursor: "pointer" }} />
                        </div>
                        <div className="modal-body deleteModalBody">
                            <p style={{ fontSize: 16, fontWeight: "bold" }}>NOTE:</p>
                            <ul className="pl-5">
                                <li>Once deleted cannot be retrieved.</li>
                                <li>All data associated with this entry will be deleted permanently.</li>
                            </ul>
                            <p className="pl-5 deleteConfirmationText">If you want to delete the entry , type <b>DELETE PERMANENTLY</b> in block/capital letters in below input text for confirmation.</p>
                            <div className="pl-5">
                                <input
                                    type="text"
                                    style={{ width: "260px" }}
                                    value={this.state.deleteAccessText}
                                    onChange={(e) => e.target.value != 'DELETE PERMANENTLY' ? this.setState({ deleteAccessText: e.target.value, deleteWarning: 'Please enter DELETE PERMANENTLY to delete access.' }) : this.setState({ deleteAccessText: e.target.value, deleteWarning: '' })}
                                    placeholder="Please type DELETE PERMANENTLY"
                                    maxLength={18}
                                    onPaste={(e) => e.preventDefault()}
                                />
                            </div>
                            <p style={{ marginLeft: 50, color: 'red', fontSize: 12, marginTop: 5 }}>{this.state.deleteWarning}</p>
                        </div>

                        <div className="modal-footer">
                            <div id="addCategoryButtonContainer" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                {
                                    this.state.deletingAccess &&
                                    <Spinner />
                                }
                                <button className="btn btn-outline-primary waves-effect" onClick={() => this.state.deleteAccessText == 'DELETE PERMANENTLY' ? this.apiCallToDeleteAccess() : this.setState({ deleteWarning: 'Please enter DELETE PERMANENTLY to delete access.' })} disabled={this.state.deletingAccess}>Yes</button>
                                <button className="btn btn-primary" onClick={() => this.closeDeleteAccess()}>No</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO CLOSE DELETE ACCESS
    closeDeleteAccess = () => {
        this.setState({
            deleteAccess: false,
            deletingAccess: false,
            deleteAccessText: '',
            deleteWarning: ''
        });
    }

    // METHOD TO SELECT ALL ACCESS
    selectAllAccess = (e) => {
        let selectAccessSet = new Set();

        if (e.target.checked) {

            Object.keys(this.state.accessDetails).map(accessKey => {
                selectAccessSet.add(accessKey);
            });
        } else {
            Object.keys(this.state.accessDetails).map(accessKey => {
                selectAccessSet.delete(accessKey);
            });
        }

        this.setState({
            selectedAccessIds: Array.from(selectAccessSet)
        });
    }

    // METHOD TO SELECT SINGLE ACCESS
    selectSingleAccess = (accessId) => {
        let selectedAccessIds = this.state.selectedAccessIds;

        if (selectedAccessIds.includes(accessId)) {

            selectedAccessIds = selectedAccessIds.filter(id => id != accessId);
        } else {
            selectedAccessIds.push(accessId);
        }

        this.setState({
            selectedAccessIds
        });
    }

    // METHOD TO CHECK ACCESS FOR ADD OPERATION
    checkAddAccess = () => {
        const addGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['setting'].find(access => access === 'add');

        if (addGrantAccess !== undefined) {
            this.setState({
                addAccess: true
            });
        }
        else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // METHOD TO CHECK ACCESS FOR DELETE OPERATION
    checkDeleteAccess = () => {
        const deleteGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['setting'].find(access => access === 'delete');

        if (deleteGrantAccess !== undefined) {
            this.setState({
                deleteAccess: true
            });
        }
        else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    openActivitySlider = (id) => {
        this.setState({
            selectedIid: id,
            showActivitySlider: true
        });
    };

    closeActivitySlider = () => {
        this.setState({
            selectedIid: "",
            showActivitySlider: false
        });
    };

    render() {

        return (
            <>
                <RoutingMenu activeScreen="grantaccess" />
                <div className="libraryComponents-container">
                    <div className=" row col-md-12">
                        <button className="btn closeDetails" title="Click to visit back to library settings" style={{ marginRight: '10px' }} onClick={() => this.props.closeGrantAccess()} >
                            <FontAwesomeIcon className="" icon={["fa", "angle-left"]} />
                        </button>
                        &nbsp;
                        <div className="mt-1">
                            <h3 style={{ fontSize: "28px" }}>Grant Access</h3>
                        </div>
                    </div>
                    <div className="pr-2" style={{ marginTop: 1 }}>
                        <div id="locationListHeaderElements">
                            <div id="routingMenuContainer">
                                <button className="btn btn-outline-primary waves-effect" onClick={() => this.checkAddAccess()}>
                                    <FontAwesomeIcon icon={['fas', 'plus']} size="md" title="Click to add new access" style={{ marginRight: 5 }} />
                                    Grant New Access
                                </button>
                            </div>
                        </div>
                        <div className="table-responsive col-12" style={{ marginTop: 10 }}>
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th style={{ padding: 5 }}>
                                            <input
                                                type="checkbox"
                                                checked={Object.keys(this.state.accessDetails).length > 0 && (Object.keys(this.state.accessDetails).length == this.state.selectedAccessIds.length)}
                                                onClick={(e) => this.selectAllAccess(e)}
                                            />
                                        </th>
                                        <th style={{ padding: 5 }}>Sr. No.</th>
                                        <th style={{ padding: 5 }}>Access Owner</th>
                                        <th style={{ padding: 5 }}>Role</th>
                                        <th style={{ padding: 5 }} colSpan={2}>Accessible Screen</th>
                                        <th style={{ padding: 5 }}>Added By</th>
                                        <th style={{ padding: 5 }}>Modified By</th>
                                    </tr>
                                    {
                                        this.state.selectedAccessIds.length > 0 &&
                                        <tr className="active-row">
                                            <th colSpan="8" style={{ padding: 2 }}>
                                                <div className="componentAction-button">
                                                    <span className="deleteAccess" onClick={() => this.getAccessUpdateDetails()}>
                                                        Update
                                                        </span>
                                                    <span className="deleteAccess" onClick={() => this.checkDeleteAccess()}>
                                                        Delete
                                                        </span>
                                                </div>
                                            </th>
                                        </tr>
                                    }
                                </thead>
                                <tbody>
                                    {
                                        this.state.accessFetching ?
                                            <tr>
                                                <td style={{ padding: 5 }} colSpan={8}>
                                                    <Spinner />
                                                </td>
                                            </tr>
                                            :
                                            Object.keys(this.state.accessDetails).length > 0 ?
                                                Object.values(this.state.accessDetails).map((access, accessIndex) => {
                                                    return (
                                                        <>
                                                            <tr key={access.uniqueId}>
                                                                <td style={{ padding: 5 }} rowSpan={Object.keys(access.access).length > 0 ? Object.keys(access.access).length : 1}>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={this.state.selectedAccessIds.includes(access.uniqueId.toString())}
                                                                        onClick={() => this.selectSingleAccess(access.uniqueId.toString())}
                                                                    />
                                                                </td>
                                                                <td style={{ padding: 5 }} rowSpan={Object.keys(access.access).length > 0 ? Object.keys(access.access).length : 1}>{accessIndex + 1}.</td>
                                                                <td style={{ padding: 5 }} rowSpan={Object.keys(access.access).length > 0 ? Object.keys(access.access).length : 1}>{access.facultyName}</td>
                                                                <td style={{ padding: 5 }} rowSpan={Object.keys(access.access).length > 0 ? Object.keys(access.access).length : 1}>{access.facultyRole}</td>
                                                                {
                                                                    Object.keys(access.access).length > 0 ?
                                                                        Object.keys(access.access).map((accessKey, accessKeyIndex) => {
                                                                            if (accessKeyIndex == 0) {
                                                                                return (
                                                                                    <>
                                                                                        <td style={{ padding: 5, textTransform: 'capitalize' }}>{accessKey}</td>
                                                                                        <td style={{ padding: 5, textTransform: 'capitalize' }}>{access.access[accessKey].join(', ')}</td>
                                                                                    </>
                                                                                );
                                                                            }
                                                                        })
                                                                        :
                                                                        <>
                                                                            <td style={{ padding: 5 }}></td>
                                                                            <td style={{ padding: 5 }}></td>
                                                                        </>
                                                                }
                                                                <td style={{ padding: 5 }} rowSpan={Object.keys(access.access).length > 0 ? Object.keys(access.access).length : 1}>{access.addedByName}</td>
                                                                <td style={{ padding: 5, cursor: "pointer", color: access.uniqueId == this.state.hoverID ? "#0465AC" : "" }}
                                                                    rowSpan={Object.keys(access.access).length > 0 ? Object.keys(access.access).length : 1}
                                                                    onMouseEnter={() => this.setState({ hoverID: access.uniqueId })}
                                                                    onMouseLeave={() => this.setState({ hoverID: "" })}
                                                                    onClick={() => this.openActivitySlider(access.uniqueId)}>
                                                                    {access.updatedByName}
                                                                </td>
                                                            </tr>
                                                            {
                                                                Object.keys(access.access).length > 0 &&
                                                                Object.keys(access.access).map((accessKey, accessKeyIndex) => {
                                                                    if (accessKeyIndex > 0) {
                                                                        return (
                                                                            <tr>
                                                                                <td style={{ padding: 5, textTransform: 'capitalize' }}>{accessKey}</td>
                                                                                <td style={{ padding: 5, textTransform: 'capitalize' }}>{access.access[accessKey].join(', ')}</td>
                                                                            </tr>
                                                                        );
                                                                    }
                                                                })
                                                            }
                                                        </>
                                                    );
                                                })
                                                :
                                                <tr>
                                                    <td style={{ padding: 5 }} colSpan={8}>No access is given yet. Please click on 'Grant New Access' to grant access.</td>
                                                </tr>
                                    }
                                </tbody>
                            </table>
                            <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', flexWrap: "nowrap", marginBottom: 15 }}>
                                <div className="perPageSelectContainer" style={{ fontSize: 13, fontWeight: "bold" }}>
                                    <span >Show</span>
                                    <select
                                        className="mx-2"
                                        value={this.state.limitAccess}
                                        onChange={(e) => this.getLimitPerPageAccess(e)}
                                    >
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={40}>40</option>
                                        <option value={100}>100</option>
                                        <option value={250}>250</option>
                                    </select>
                                    <span>entries</span>
                                </div>
                                {
                                    Object.values(this.state.accessDetails).length > 0 &&
                                    <div id="paginationContainer">
                                        <Pagination
                                            activePage={this.state.page_indexAccess}
                                            itemsCountPerPage={this.state.limitAccess}
                                            totalItemsCount={parseInt(this.state.totalCountAccess)}
                                            pageRangeDisplayed={3}
                                            onChange={(num) => this.updatePaginationCountAccess(num)}
                                        />
                                    </div>
                                }
                                <p className="mx-2" style={{ fontWeight: 'bold', fontSize: 13 }}>Total Records: {this.state.totalCountAccess}</p>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.state.successModal &&
                    <SuccessModal
                        successModal={this.state.successModal}
                        successModalType={this.state.successModalType}
                        successMessage={this.state.successMessage}
                        closeSuccessModal={this.closeSuccessModal}
                    />
                }
                {
                    this.returnGrantAccess()
                }
                {
                    this.returnSelectFaculty()
                }
                {
                    this.returnDeleteAccess()
                }
                {
                    this.state.showActivitySlider && this.state.selectedIid != "" &&
                    <SpecificUserLog
                        showSlider={this.state.showActivitySlider}
                        closeSlider={this.closeActivitySlider}
                        logUid={this.state.selectedIid}
                        activityArr={["userAccess_updated", "UserAccess_added", "userAccess_updated", "userAccess_deleted"]}
                    />
                }
            </>
        )
    }
}

const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        assignedInstitute: { ...store.RouteMenuReducer.assignedInstitute },
        assignedIIDArray: { ...store.RouteMenuReducer.assignedIIDArray },
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin,
        iidArray: { ...store.RouteMenuReducer.iidArray },
        multipleInstituteDetails: { ...store.RouteMenuReducer.multipleInstituteDetails }
    };
};


export default connect(mapStateToProps)(GrantAccess);
